import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import Button from '@styles/buttons';

import type { WelcomeStepProps } from '@components/tenantStatus/onboardingWizard/types';

const WelcomeStep = ({ C, onGetStarted, testID }: WelcomeStepProps) => {
  return (
    <View style={{ alignItems: 'center' }}>
      <Text
        style={[
          font['Title 2'],
          { color: C('Label/Light/Primary'), textAlign: 'center', marginBottom: scale(8) },
        ]}
      >
        {i18n.t('Get more out of your machines!')}
      </Text>
      <Text
        style={[
          font['Body'],
          {
            color: C('Label/Light/Tertiary'),
            textAlign: 'center',
            marginBottom: scale(28),
          },
        ]}
      >
        {i18n.t('Four quick questions, then we take care of the rest.')}
      </Text>
      <Button
        variant="L"
        type="Primary"
        onPress={onGetStarted}
        testID={testID}
        colors={{
          bgColor: 'Other/Light/Logo/Smart',
          textColor: 'Label/Light/AlwaysLight Primary',
        }}
      >
        {i18n.t('Get started')}
      </Button>
    </View>
  );
};

export default WelcomeStep;
